export default __webpack_public_path__ + "static/media/mesh_hea.30b9ac41.png";